import {createRouteRef, createSubRouteRef} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'pequi-github-actions',
});



export const buildRouteRef = createSubRouteRef({
  id: 'pequi-github-actions/build',
  path: '/:id',
  parent: rootRouteRef,
});

